import {
  animate,
  style,
  transition,
  trigger
} from '@angular/animations';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ServiceWorkerUpdateService } from './services/service-worker-update.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('100ms', style({ opacity: 1 })),
      ]),
    ]),
    trigger('fadeOut', [
      transition(':leave', [
        style({ opacity: 1 }),
        animate('100ms', style({ opacity: 0 })),
      ]),
    ]),
  ],
})
export class AppComponent implements OnInit, OnDestroy {
  environment = environment;
  private destroy$ = new Subject<void>();

  constructor(
    private primengConfig: PrimeNGConfig,
    private translateService: TranslateService,
    private swUpdateService: ServiceWorkerUpdateService,
    private confirm: ConfirmationService,
    private swUpdate: SwUpdate
  ) { }

  async ngOnInit() {
    this.primengConfig.ripple = true;
    this.translateService.setDefaultLang('es');
    this.translate('es');

    // Subscribirse a las actualizaciones del Service Worker
    this.swUpdateService.updateAvailable$
      .pipe(takeUntil(this.destroy$))
      .subscribe((updateAvailable) => {
        if (updateAvailable) {
          this.showUpdateModal();
        }
      });
    // this.showUpdateModal();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private showUpdateModal() {
    this.confirm.confirm({
      key: 'updateDialog',
      header: '🚀 Actualización disponible',
      message:
        'Hay una nueva versión disponible con mejoras y correcciones. Actualice para aplicar los cambios.',
      acceptLabel: 'Actualizar ahora',
      rejectVisible: false,
      icon: 'pi pi-sync',
      accept: async () => {
        await this.swUpdate.activateUpdate();
        location.reload();
      }
    });
  }

  translate(lang: string) {
    this.translateService.use(lang);
    this.translateService
      .get('primeng')
      .subscribe((res) => this.primengConfig.setTranslation(res));
  }

  isDragging = false;
  @HostListener('dragenter', ['$event'])
  onDragEnter(ev: DragEvent) {
    ev.preventDefault();
    const inputElement = document.getElementById(
      'upload-file'
    ) as HTMLInputElement;
    if (inputElement) this.isDragging = true;
  }

  @HostListener('dragleave', ['$event'])
  onDragLeave(ev: DragEvent) {
    // Verifica que el mouse realmente haya salido del navegador
    if (
      ev.clientX <= 0 ||
      ev.clientY <= 0 ||
      ev.clientX >= window.innerWidth ||
      ev.clientY >= window.innerHeight
    ) {
      this.isDragging = false;
    }
  }

  @HostListener('dragover', ['$event'])
  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  @HostListener('drop', ['$event'])
  async onDrop(event: DragEvent) {
    event.preventDefault();
    this.isDragging = false;
  }
}
